import { createPortal } from 'react-dom';
import Spa
    from "@components/spas/Spa";

function ReactPortal({ children, targetId }) {
    return createPortal(<Spa>{children}</Spa>, document.getElementById(targetId));
}
export default ReactPortal;